export default {
  title: "Connexion avec code d'accès",
  subtitle: "Entrez le code à 6 chiffres pour accéder à l'espace collaboratif"
};
